import React from 'react'
import { Share } from '@which/seatbelt'
import { getSharingUrl } from '../../../components/common/utilities/get-sharing-url'
import './sharing-options-vertical.scss'

interface Props {
  url: string
  fbappid: string
  twitterText: string
  facebookText: string
  emailSubject: string
}

const WSharingOptionsVertical = ({
  url,
  fbappid,
  twitterText,
  facebookText,
  emailSubject,
}: Props): React.ReactElement => {
  return (
    <div className="sharing-options-vertical-layout" data-testid="sharing-options-vertical">
      <Share
        links={{
          facebook: getSharingUrl({ url, fbappid, type: 'facebook' }),
          twitter: getSharingUrl({ url, text: twitterText, type: 'twitter' }),
          mail: getSharingUrl({ url, text: facebookText, emailSubject, type: 'email' }),
        }}
        block
      />
    </div>
  )
}

export default WSharingOptionsVertical
